import newCampaign from "./newCampaign";
import viewCampaigns from "./viewCampaigns";
import rewards from "./rewards";
import emailThemes from "./emailThemes";

export default {
    namespaced: true,
    modules: {
        newCampaign,
        viewCampaigns,
        rewards,
        emailThemes
    }
};
